import { useEvent } from "@ispb/react-hooks";
export function useKeyPageNavigation(page, setPage, pages) {
    useEvent(window, "keyup", event => {
        if (event.key === "PageUp") {
            setPage(page => Math.max(page - 1, 0));
        }
        if (event.key === "PageDown") {
            setPage(page => Math.min(page + 1, pages - 1));
        }
    });
}
